import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'

const MainScreen: React.FC = () => {
  return (
    <Screen
      size="large"
      title={<span><StyledScreen.GreenText>Телефония</StyledScreen.GreenText> для тех,<br />кто ценит каждого клиента</span>}
      bottomLine={true}
    >
      <Styled.SubTitle>с бесплатной интеграцией в любую CRM</Styled.SubTitle>
      <Form
        free
        formType='service'
        text='Попробовать сервис'
        pageName='Главная'
      />
    </Screen>
  )
}

export { MainScreen }